
import { useContext } from "react";

import { Check, ChevronDown } from "lucide-react";

import { validateAnswers } from "../../../../lib/helper";

import { AnswerContext } from "../../../../state/answers";

import { Checkbox, CheckboxGroup } from "../../../../components/checkbox";

import { Error } from "../../../../components/error";

import { Field } from "../../../../components/field";

import { Label } from "../../../../components/label";

import { Radio, RadioGroup } from "../../../../components/radio-group";

import { 
  
  Listbox,

  ListboxButton,

  ListboxOption,

  ListboxOptions,

  ListboxSelectedOption 

} from "../../../../components/listbox";

export function Answers( { answers, question } ) {

  const { selectedAnswers, updateAnswers } = useContext( AnswerContext );

  const answersInvalid = Object.hasOwn( question, "answers" ) && validateAnswers( question.answers );

  const useCheckbox = question.format === "checkbox";

  const useListbox = question.format === "listbox";

  const useRadioGroup = question.format === "radio";

  const handleChange = value => {

    const answer = answers.filter( answer => answer.value === value );

    updateAnswers( question.id, answer );

  }

  const selected = selectedAnswers.filter( selected => selected.question_id === question.id  )[ 0 ]?.answers?.map( a => a.value ) || [];

  return (

    <div className="col-start-2">
      
      { useListbox && (

        <Listbox value={ selected[0] ?? null } onChange={ handleChange }>

          { answersInvalid && <Error>{ question.error }</Error> }

          <ListboxButton aria-invalid={ answersInvalid } >

            <ListboxSelectedOption 
            
              options={ selected[0] } 
              
              placeholder={ 
              
                <span className="text-grey-dark">
                  
                  { question?.placeholder }
                  
                </span> 
                
              } 
              
            />

            <ChevronDown className="text-grey-dark" />

          </ListboxButton>

          <ListboxOptions>

            { answers.map( answer => (
              
              <ListboxOption key={ answer.id } value={ answer.value }>

                <Check className="stroke-black invisible group-data-selected:visible" />

                { answer.label }

              </ListboxOption>

            ) ) }

          </ListboxOptions>

        </Listbox>

      ) }

      { useCheckbox && (
        
        <>

          { answersInvalid && <Error>{ question.error }</Error> }

          <CheckboxGroup>

            { answers.map( answer => (

              <Field key={ answer.id }>

                <Checkbox

                  checked={ selected?.includes( answer.value ) }

                  onChange={ () => handleChange( answer.value ) }

                  aria-invalid={ answersInvalid }

                >

                  <Check className="stroke-white invisible group-data-checked:visible" />
                  
                </Checkbox>

                <Label>{ answer.label }</Label>

              </Field>

            ) ) }

          </CheckboxGroup>

        </>

      ) }

      { useRadioGroup && (

        <>

          { answersInvalid && <Error>{ question.error }</Error> }

          <RadioGroup value={ selected[0] ?? null } onChange={ handleChange }>

            { answers.map( answer => (

              <Field key={ answer.id }>

                <Radio value={ answer.value } aria-invalid={ answersInvalid }>

                  <Check className="stroke-white size-3 invisible group-data-checked:visible" />

                </Radio>

                <Label>{ answer.label }</Label>

              </Field>

            ) ) }

          </RadioGroup>

        </>

      )}

    </div>

  )

}
